

import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { useSelector } from "react-redux"
import locationData from "../../../../utils/locationData/locationOptions"
import { handleActiveSelect } from "../../../../features/layout/layoutSlice"
import textFilter from "../../../../helper/textFilter"
import { updateBolgedekiTekliflerItemLocation } from "../../../../features/bolgedekiTekliflerim/bolgedekiTekliflerimSlice"

const Container = styled.div`
    width: 100%;
    height: 33px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    input{
        width: 100%;
        height: 100%;
        padding: 0 15px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    .options{
        position: absolute;
        top: 34px;
        left: -1px;
        right: 1px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 251px;
        border: 1px solid ${({theme}) => theme.mainTextColor};
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        height: 300px;
        overflow: auto;

        .option{
            width: 100%;
            padding: 9px 20px;
            cursor: pointer;


            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }
    }

`

const InputCityTownBolgedekiTekliflerim = ({item, keyData, townId, name, placeholder}) => {

    const dispatch = useDispatch()
    const [text, setText] = useState("")
    const { bolgedekiTeklifler} = useSelector(state => state.bolgedekiTekliflerim)

    //! bu seçilenlere göre filtreleme
    const [options, setOptions] = useState(locationData)

    //! bu ekranda inputta yapılan filtreleme 
    const [searchFilterOptions, setSearchFilterOptions] = useState([])

    const {activeSelect} = useSelector(state => state.layout)

    useEffect(() => {
        setText(locationData.find(item => item.townId === townId.toString())?.location || "")
    }, [item])

    useEffect(() => {
        
        if(keyData === "from"){
            const from = bolgedekiTeklifler.filter((bolgeItem) => {
                return (item.toTownId?.toString() === bolgeItem.toTownId?.toString() && bolgeItem.fromCityId && bolgeItem.fromTownId)
            })

            const idList = from.map(item => item.fromTownId.toString()).filter(innerItem => innerItem !== item.fromTownId.toString())

            const filteredLocation = locationData.filter(locationItem => {
                return !idList.includes(locationItem.townId.toString())
            })

            setOptions(filteredLocation)
        }
        else{
            const to = bolgedekiTeklifler.filter((bolgeItem) => {
                return (item.fromTownId?.toString() === bolgeItem.fromTownId?.toString() && bolgeItem.toCityId && bolgeItem.toTownId)
            })
            const idList = to.map(item => item.toTownId.toString()).filter(innerItem => innerItem !== item.toTownId.toString())

            const filteredLocation = locationData.filter(locationItem => {
                return !idList.includes(locationItem.townId.toString()) 
            })

            setOptions(filteredLocation)

        }

    },[bolgedekiTeklifler, item])


    useEffect(() => {
        setSearchFilterOptions(options)
    },[options])

    const handleChange = (e) => {
        const searchText = e.target.value
        dispatch(handleActiveSelect(name))

        if(searchText){
            const result = textFilter(options, searchText, "location")
            setSearchFilterOptions(result)
        }
        else{
            setSearchFilterOptions(options)
        }

        setText(searchText)
    }

    const handleOptionClick = (optionItem) => {

        dispatch(updateBolgedekiTekliflerItemLocation({locationData:optionItem, id: item.id, keyData}))
        setText(item.location)
        dispatch(handleActiveSelect(null))
    }

  return (
    <Container onClick={(e) => e.stopPropagation()}>
        <input type="text" id={"text"} onChange={handleChange} value={text} name={name} onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))} autoComplete="off" placeholder={placeholder}/> 
            {
                activeSelect === name &&
                <div className="options">
                    {
                        searchFilterOptions.map((item) => (
                            <div key={item.id} className="option" onClick={() => handleOptionClick(item)}>
                                {item.location}
                            </div>
                        ))
                    }
                </div>
            }
    </Container>
  )
}

export default InputCityTownBolgedekiTekliflerim
